import { objectOf } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { getNumberUnit, isCRMManagement } from '@utils/Util';

const Overview = ({ summary }) => {
	const filterFields = useSelector((store) => store.filterFieldStore);

	const renderCountryName = () => {
		if (isCRMManagement()) {
			return filterFields?.countryId?.[0]?.key
				? `Overview (${filterFields?.countryId?.[0]?.value})`
				: filterFields?.accountManagerId?.[0]?.key
					? `Overview (${filterFields?.accountManagerId?.[0]?.value})`
					: 'Global Overview';
		} else {
			return 'Overview';
		}
	};

	return (
		<>
			<h3 className="semibold-14 mb-2">{renderCountryName()}</h3>
			<div className="overview-container">
				<div className="overview-item-list">
					<div className="overview-item">
						<p className="regular-14 gray_dark_02 mb-1">Target</p>
						<h4 className="regular-16 weight-500 gray_dark_01">
							{getNumberUnit(summary?.targetAmount, true)}
						</h4>
					</div>
					<div className="overview-item">
						<p className="regular-14 gray_dark_02 mb-1">Revenue Pipeline</p>
						<h4 className="regular-16 weight-500 gray_dark_01">
							{getNumberUnit(summary?.revenuePipelineAmount, true)}
						</h4>
					</div>
					<div className="overview-item">
						<p className="regular-14 gray_dark_02 mb-1">Achieved</p>
						<h4 className="regular-16 weight-500 gray_dark_01">
							{getNumberUnit(summary?.achievedAmount, true)}
						</h4>
					</div>
					<div className="overview-item">
						<p className="regular-14 gray_dark_02 mb-1">Nitex Style(Achieved)</p>
						<h4 className="regular-16 weight-500 gray_dark_01">
							{getNumberUnit(summary?.nitexDesignSold)}
						</h4>
					</div>
					<div className="overview-item">
						<p className="regular-14 gray_dark_02 mb-1">No. of Unit</p>
						<h4 className="regular-16 weight-500 gray_dark_01">
							{getNumberUnit(summary?.noOfUnitSold)}
						</h4>
					</div>
					<div className="overview-item">
						<p className="regular-14 gray_dark_02 mb-1">Expected Margin</p>
						<h4 className="regular-16 weight-500 gray_dark_01">
							{getNumberUnit(summary?.expectedMargin, true)}
						</h4>
					</div>
					<div className="overview-item">
						<p className="regular-14 gray_dark_02 mb-1">Styles Sold</p>
						<h4 className="regular-16 weight-500 gray_dark_01">
							{getNumberUnit(summary?.brandDesignSold + summary?.nitexDesignSold)}
						</h4>
					</div>
				</div>
			</div>
		</>
	);
};

Overview.propTypes = {
	summary: objectOf.isRequired
};

export default Overview;
